module.exports = __webpack_public_path__ + "img/arrival_10.8ea781ca.jpg";